import React from 'react';
import { action, observable } from 'mobx';
import { observer } from 'mobx-react';

import { Button } from '@smartplatform/ui';
import MenuItem from './MenuItem';
import store from '../../store';
import './style.scss';

@observer
export default class List extends React.Component {

	@observable records = [];
	@observable isLoading = true;
	@observable isAdding = false;

	constructor(props) {
		super(props);
		this.init();
	};

	init = async () => {
		this.isAdding = false;
		this.records = await store.model.MenuItem.find({
			where: { column: this.props.column },
			order: 'weight asc '
		});
		this.isLoading = false;
	};

	showAddForm = () => this.isAdding = true;

	render() {
		if (this.isLoading) return '...';

		return <div className="main-menu-edit">
			{this.records.map((item, i, items) => {
				const prev = i > 0 ? items[i - 1] : null;
				const next = i < items.length - 1 ? items[i + 1] : null;
				return <MenuItem key={item.id} item={item} onChange={this.init} prev={prev} next={next} />;
			})}
			<div className="actions">
				{this.isAdding ?
					<MenuItem onChange={this.init} isNew column={this.props.column}/>
					:
					<Button className="btn-primary" onClick={this.showAddForm}>Добавить</Button>
				}
			</div>
		</div>;
	}
}
